import Client from './client';

export default class FlowLabProjects extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/lab/projects`, options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/lab/projects`, {
      ...options,
       method: 'POST',
    });
  }

  getByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/lab/projects/${key}`, options);
  }

  putByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/lab/projects/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/lab/projects/${key}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
